<template>
  <div class="footer">
    <div class="container">
      <!-- 上层 -->
      <div class="f-s">
        <div class="s-l"><h2>北京多用信息技术有限公司</h2></div>
        <div class="s-r">
          <h1>联系我们</h1>
          <!-- <h3>固话：010-82625755</h3> -->
          <h3>邮箱：65956674@qq.com</h3>
          <h3>地址：北京市海淀区上地中关村软件园1期8号楼华夏科技大厦</h3>
        </div>
      </div>

      <div class="icp">
        <a href="https://beian.miit.gov.cn/#/Integrated/index"
          >备案编号：京ICP备2021010871号</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-footer",

  props: {
    email: String,
    phone: String,
    icp: String,
    name: String,
    addr: String,
  },
  methods: {
    // 跳转最新文章
    goAc1() {
      this.$router.push("/ac1");
    },
    // 跳转行业资讯
    goAc2() {
      this.$router.push("/ac2");
    },
    // 跳转独加新闻
    goAc3() {
      this.$router.push("/ac3");
    },
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    goHome() {
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.footer {
  height: 200px;
  width: 100%;
  background: #21272f;
  .container {
    height: 100%;
    padding-top: 10px;
    box-sizing: border-box;
    .f-s {
      width: 100%;
      height: 150px;
      // background-color: #fff;
      border-bottom: 1px solid #fff;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .s-l {
        font-size: 21px;
        color: #fff;
      }
      .s-r {
        h1 {
          font-size: 21px;
          color: #fff;
        }
        h3 {
          font-size: 16px;
          color: #fff;
          margin: 20px 0;
        }
      }
    }

    .icp {
      width: 100%;
      height: auto;
      line-height: 35px;
      text-align: center;
      a {
        font-size: 12px;
        color: #fff;
        font-weight: bold;
      }
    }
  }
}
</style>
